const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class BrandCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.4,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 2,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('brand-carousel')) {
  customElements.define('brand-carousel', BrandCarousel)
}
